export const MESSAGES_KEY = 'translations';
export const MESSAGES_VERSION_KEY = 'translations-version';
